"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderImagesStoredWorkflowOutputSchema = exports.StoredDesignRenderSchema = exports.RenderImagesWorkflowInputSchema = exports.RENDER_IMAGES_WORKFLOW_NAME = void 0;
const zod_1 = require("zod");
exports.RENDER_IMAGES_WORKFLOW_NAME = 'renderImagesWorkflow';
exports.RenderImagesWorkflowInputSchema = zod_1.z.object({
    dataLocation: zod_1.z.string(),
    outputLocationPrefix: zod_1.z.string().endsWith('/'),
    renderDesignIds: zod_1.z.string().array().optional(),
    dimensions: zod_1.z.object({ x: zod_1.z.number(), y: zod_1.z.number() }).array().optional(),
    presignGrant: zod_1.z.string().min(1),
});
exports.StoredDesignRenderSchema = zod_1.z.object({
    dimensions: zod_1.z.object({ x: zod_1.z.number(), y: zod_1.z.number() }),
    location: zod_1.z.string(),
    size: zod_1.z.number(),
    fileType: zod_1.z.string(),
    mimeType: zod_1.z.string(),
});
exports.RenderImagesStoredWorkflowOutputSchema = zod_1.z.object({
    designRenders: zod_1.z.record(zod_1.z.string(), exports.StoredDesignRenderSchema.array()),
});
//# sourceMappingURL=render-images.contract.js.map